const x = {
  none: "none",
  outline: "0 0 0 3px var(--sgi-colors-teal-200)",
  invalidOutline: "0 0 0 3px var(--sgi-colors-red-200)",
  lg: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
  xl: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)"
};
export {
  x as default
};
